import { render, staticRenderFns } from "./NewsInfo.vue?vue&type=template&id=3476a00e&scoped=true&"
import script from "./NewsInfo.vue?vue&type=script&lang=js&"
export * from "./NewsInfo.vue?vue&type=script&lang=js&"
import style0 from "./NewsInfo.vue?vue&type=style&index=0&id=3476a00e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3476a00e",
  null
  
)

export default component.exports